import * as ng from 'angular';
import { ConservazioneService } from '../../../../services/conservazione.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class ConservazioneCaricaMailPecSummaryController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        'ArchiSmallServices',
        '$uibModal',
        'ConservazioneService'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ConservazioneService: ConservazioneService
    ) {
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Riepilogo';

        let result = store.get('ConservazioneCaricaDocumento-Result');
        if (result === undefined) {
            $state.go('home.home-index');
        }
        $scope.result = result;
        $scope.next = () => {
            store.remove('ConservazioneCaricaDocumento-Result');
            store.set('fromState', $state.current.name);

            $scope.goToNextState();
        };

        let checkIfDocumentsWereProcessedOK = () => {
            return $scope.result.messageResult.wasOK !== undefined && $scope.result.messageResult.wasOK;
        };

        $scope.goToNextState = () => {
            let nextState = '';

            if (checkIfDocumentsWereProcessedOK()) {
                $state.go('home.verifica-documenti-caricati', ({ classeDocumentale: 'mail_pec' }));
            } else {
                $scope.getMailPecDaVerificareDocuments().then((response: any) => {
                    if (response != null) {
                        if (response.itemsCount > 0) {
                            $state.go('home.verifica-documenti-caricati', ({ classeDocumentale: 'mail_pec' }));
                        } else {
                            $state.go('home.conservazione');
                        }
                    }
                });
            }
        };

        $scope.getMailPecDaVerificareDocuments = () => {

            return ConservazioneService.getMailPecDaVerificareDocuments()
                .then((response) => {
                    return response;
                });
        };

    }
}

export const ConservazioneCaricaMailPecSummaryComponent: ng.IComponentOptions = {
    template: require('./conservazione-carica-mail-pec-summary.html'),
    controller: ConservazioneCaricaMailPecSummaryController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-mail-pec-summary/conservazione-carica-mail-pec-summary.ts